import "./index.css";
import { useEffect, useMemo } from "react";
import CompleteChat from "../../components/chat/CompleteChat/Index";
import {
  IChatList,
  selectorConversation,
  selectorChatId,
  actionSetConversations,
} from "../../redux/chatSlice";
import { useDispatch } from "react-redux";
import { actionSetCurrentModel, actionSetPageTitle } from "../../redux/layout";
import { useSelector } from "react-redux";
import { selectorProjects } from "../../redux/projectSlice";

export interface ChatCreateParams {
  chat_id: number;
  project_id: number;
  message: string;
  knowledge_id: number;
}

const HomePage = () => {
  const dispatch = useDispatch();
  const selectedChat = useSelector(selectorChatId);
  const conversations = useSelector(selectorConversation);
  const projects = useSelector(selectorProjects);

  const setProjectTitle = (projectId: number) => {
    if (projectId > 0) {
      const project = projects.find((proj) => proj.id === projectId);
      if (project) {
        dispatch(actionSetPageTitle(project.title));
        dispatch(actionSetCurrentModel(project.model.display_name));
      }
    }
  };

  const onChatCreate = (createChat: ChatCreateParams) => {
    const chatItem: IChatList = {
      project_id: createChat.project_id,
      title: createChat.message,
      id: createChat.chat_id,
      knowledge_id: createChat.knowledge_id,
      created_at: new Date().toISOString(),
    };
    const listConversation = [chatItem, ...conversations];
    dispatch(actionSetConversations(listConversation));
  };

  const project_id = useMemo(() => {
    let project_id = undefined;
    if (selectedChat?.selectedChatId) {
      // Com o chat vazio o valor do selectedChatId corresponde ao projeto
      if (selectedChat.emptyChat) {
        project_id = selectedChat.selectedChatId;
      } else {
        // Chat nao esta vazio, temos que puxar o projeto pela conversa em si
        const conversation = conversations.find((item) => item.id === selectedChat.selectedChatId);
        if (conversation && conversation.project_id) {
          project_id = conversation.project_id;
        }
      }
    }
    return project_id;
  }, [selectedChat]);

  useEffect(() => {
    if (project_id) {
      setProjectTitle(project_id);
    }
  }, [project_id]);

  return (
    <div className="page-content">
      <div translate="no">
        <CompleteChat project_id={project_id} onChatCreate={onChatCreate} />
      </div>
    </div>
  );
};

export default HomePage;
